import {Box, Skeleton} from '@mui/material';

const HeaderSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
    }}>
    <Box display={'flex'} alignItems={'center'}>
      <Skeleton variant="rounded" width={30} height={30} />
      <Skeleton variant="rounded" sx={{ml: 2}} width={120} height={30} />
    </Box>
    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
      <Skeleton variant="text" width={70} height={20} />
      <Skeleton variant="text" width={70} height={20} />
    </Box>
  </Box>
);

export default HeaderSkeleton;
